import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import {LoginContain, LoginFooter } from "../../style/Login/SendOtp";
import { ToastContainer, toast } from "react-toastify";
import { Loader } from "../../utils/loader";
import { SendOTP } from "../../services/authServices";
import Logo from "../../assets/images/logo.png";

function SendOtp() {
  const [loading, setLoading] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const userData = location.state?.data;


    useEffect(() => {
      if (!userData || !userData.userId) {
        navigate("/", { replace: true });
      }
    }, [userData, navigate]);

  const handleSubmitOtp = async (e) => {
    e.preventDefault();

    try {
      setLoading(true);

      if (!userData?.userId) {
        toast.error("User information is missing");
        return;
      }

      const payload = {
        userId: userData.userId,
      };

      const response = await SendOTP(payload);

      if (response.success) {
        toast.success("OTP sent successfully");
        navigate("/verify-otp", {
          state: { data: userData },
        });
      } else {
        toast.error(response.message || "Failed to send OTP");
      }
    } catch (error) {
      toast.error(error?.response?.data?.message || "Failed to send OTP");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <ToastContainer />
      <LoginContain>
        <div className="LoginCard">
          <div className="LoginLogo">
            <img src={Logo} alt="logo"  loading="lazy"/>
          </div>
          <div className="LoginTitle">
            <h4>Send OTP</h4>
            <p>Verify your details to receive an OTP.</p>
          </div>
          <form onSubmit={handleSubmitOtp}>
            <div className="LoginGroup">
              <label htmlFor="user-email" className="forgot-label">
                User Email
              </label>
              <input
                type="text"
                id="user-email"
                className="forgot-input"
                value={userData?.emailId || ""}
                placeholder="No email available"
                readOnly
              />
            </div>
            <div className="LoginGroup">
              <label htmlFor="user-phone" className="forgot-label">
                User Mobile
              </label>
              <input
                type="text"
                id="user-phone"
                className="forgot-input"
                value={userData?.phoneNumber || ""}
                placeholder="No phone number available"
                readOnly
              />
            </div>
            <div className="LoginGroup LoginBtn">
              <button type="submit" disabled={loading}>
                {loading ? <Loader /> : "Send OTP"}
              </button>
            </div>
          </form>
        </div>
      </LoginContain>
      <LoginFooter>
        <p>
          POWERED BY: <span>Manthan IT Solutions</span>
        </p>
      </LoginFooter>
    </>
  );
}

export default SendOtp;
